function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 16px;\n  height: 16px;\n  color: ", ";\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  margin-top: 13px;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 350px;\n  z-index: 5;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: calc(100% - 350px);\n  transition: all 0.3s ease-in 0s;\n  background-color: ", ";\n  border-left: 1px solid ", ";\n  -webkit-box-shadow: 0px 0px 10px 1px ", ";\n  -moz-box-shadow: 0px 0px 10px 1px ", ";\n  box-shadow: 0px 0px 10px 1px ", ";\n  &.inactive {\n    transform: translateX(370px);\n  }\n  .title-filter {\n    z-index: 5;\n    width: 100%;\n    padding: 30px 30px 0px;\n    line-height: 30px;\n    height: 30px;\n  }\n  .filter-body {\n    overflow: auto;\n    height: calc(100% - 130px);\n  }\n  .cta-container {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    position: absolute;\n    background-color: #ffffff;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n    padding: 20px 0;\n    .apply-cta button {\n      padding: 2px 18px;\n      margin-left: 20px;\n      margin-right: 34px;\n    }\n    .clear-cta button {\n      padding: 1.1px 18px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomButton from '../../atoms/CustomButton';
import { defaultTheme } from '../../../utils';
import Text from '../../atoms/Text';
var FilterWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadow;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shadow;
});
var CloseButton = styled.span(_templateObject2(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.status.cancel;
});

var Filter = function Filter(_ref7) {
  var classProp = _ref7.classProp,
      handleClose = _ref7.handleClose,
      clearName = _ref7.clearName,
      applyName = _ref7.applyName,
      handleApply = _ref7.handleApply,
      handleClear = _ref7.handleClear,
      children = _ref7.children,
      isOpen = _ref7.isOpen,
      rest = _objectWithoutPropertiesLoose(_ref7, ["classProp", "handleClose", "clearName", "applyName", "handleApply", "handleClear", "children", "isOpen"]);

  var filterRef = useRef();
  useEffect(function () {
    if (isOpen) {
      document.addEventListener('click', handleClick);
    }

    return function cleanup() {
      document.removeEventListener('click', handleClick);
    };
  }, [isOpen]);

  var handleClick = function handleClick(event) {
    try {
      if (filterRef && filterRef.current.contains(event.target)) {
        return;
      }

      handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  return /*#__PURE__*/React.createElement(FilterWrapper, _extends({
    className: "filter-wrapper " + classProp + " " + (isOpen ? 'active' : 'inactive')
  }, rest, {
    ref: filterRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-filter"
  }, /*#__PURE__*/React.createElement(Text, {
    text: "Filters",
    size: "header3",
    variant: "bold"
  }), /*#__PURE__*/React.createElement(CloseButton, _extends({}, rest, {
    onClick: function onClick() {
      return handleClose();
    }
  }), "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "filter-body"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "cta-container"
  }, handleClear && /*#__PURE__*/React.createElement("div", {
    className: "clear-cta"
  }, /*#__PURE__*/React.createElement(CustomButton, {
    variant: "outlined",
    onClick: handleClear
  }, clearName)), handleApply && /*#__PURE__*/React.createElement("div", {
    className: "apply-cta"
  }, /*#__PURE__*/React.createElement(CustomButton, {
    variant: "contained",
    onClick: handleApply
  }, applyName))));
};

Filter.propTypes = process.env.NODE_ENV !== "production" ? {
  classProp: PropTypes.string,
  handleClose: PropTypes.func,
  clearName: PropTypes.string,
  applyName: PropTypes.string,
  handleApply: PropTypes.func,
  handleClear: PropTypes.func,
  children: PropTypes.node,
  isOpen: PropTypes.bool
} : {};
Filter.defaultProps = {
  theme: defaultTheme,
  isOpen: false,
  clearName: 'Clear',
  applyName: 'Apply',
  classProp: ''
};
export default Filter;